export class EdenFetchError extends Error {
    constructor(status, passedValue) {
        let message = String((passedValue === null || passedValue === void 0 ? void 0 : passedValue.message) || '');
        if (!message) {
            if (typeof passedValue === 'object') {
                message = JSON.stringify(passedValue);
            }
            else {
                message = String(passedValue || '');
            }
        }
        super(message);
        this.status = status;
        this.passedValue = passedValue;
        this.value = passedValue;
    }
}
//# sourceMappingURL=errors.js.map